<section class="battle-list-page">
  <app-admin-page-header 
    [title]="isFinishedPage ? 'Batalhas Finalizadas' : 'Batalhas em Andamento'" 
    subtitle="Gerencie o histórico e o status das batalhas.">
    <div header-actions>
      <button *ngIf="!isFinishedPage" (click)="onFinishedClick()" class="admin-btn admin-btn--primary">
        Ver Finalizadas
      </button>
      <button *ngIf="isFinishedPage" (click)="onPendingClick()" class="admin-btn admin-btn--primary">
        Ver Em Andamento
      </button>
    </div>
  </app-admin-page-header>

  <div class="battle-toolbar admin-surface">
    <input 
      type="text" 
      class="admin-input" 
      [(ngModel)]="searchTerm" 
      placeholder="ID ou Nome do Usuário" 
      (keydown.enter)="onSearchChange()" />

    <div class="date-range-wrapper">
      <button (click)="toggleDateFilter()" class="admin-btn admin-btn--secondary">
        {{ showDatePicker ? 'Ocultar Data' : 'Pesquisar por Data' }}
      </button>
      <p-datepicker
        *ngIf="showDatePicker"
        dateFormat="dd/mm/yy"
        selectionMode="range"
        [(ngModel)]="rangeDates"
        [readonlyInput]="true"
        (onClose)="setDateRange()"
        placeholder="Selecione o período"
        appendTo="body">
      </p-datepicker>
    </div>

    <div class="battle-toolbar__actions">
      <button (click)="onSearchChange()" class="admin-btn admin-btn--primary">Pesquisar</button>
      <button (click)="clearFiltersAndRefresh()" class="admin-btn admin-btn--secondary" [disabled]="isLoading">Limpar</button>
    </div>
  </div>

  <div class="admin-surface battle-table">
    <p-table 
      [value]="battles" 
      [paginator]="true" 
      [rows]="rowsPerPage" 
      [totalRecords]="totalItems" 
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)" 
      [loading]="isLoading">
      
      <ng-template pTemplate="header">
        <tr>
          <th>DATA E HORA</th>
          <th>PUBLIC ID</th>
          <th>USUARIOS</th>
          <th>ESPÓLIOS</th>
          <th *ngIf="!isFinishedPage">AÇÕES</th>
          <th *ngIf="isFinishedPage">RESULTADO</th>
          <th *ngIf="isFinishedPage">ALTERAR RESULTADO</th>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="body" let-battle>
        <tr *ngIf="battle">
          <td>{{ battle.created_at ? formatDateTime(battle.created_at) : '-' }}</td>
          <td>{{ battle.public_id || '-' }}</td>
          <td (click)="openPlayerModal(battle)" class="users-cell-clickable">
            <strong *ngIf="battle.players?.[0]">
              {{ battle.players[0].username || '-' }} ({{ battle.players[0].user_id || '-' }})
              <i class="pi pi-star-fill mission-icon" *ngIf="battle.players?.[0]?.accepted_mission" title="Possui missão aceita"></i>
            </strong>
            <span *ngIf="!battle.players?.[0]">-</span>
            <span *ngIf="battle.players?.[0] && battle.players?.[1]"> | </span>
            <strong *ngIf="battle.players?.[1]">
              {{ battle.players[1].username || '-' }} ({{ battle.players[1].user_id || '-' }})
              <i class="pi pi-star-fill mission-icon" *ngIf="battle.players?.[1]?.accepted_mission" title="Possui missão aceita"></i>
            </strong>
          </td>
          <td>
            <div *ngIf="getMaxStake(battle) || (isFinishedPage && battle.loot?.gems)">
              <div><strong>Moedas:</strong> {{ getMaxStake(battle) || 0 }}</div>
              <div *ngIf="isFinishedPage"><strong>Prêmio:</strong> {{ battle.loot?.gems || 0 }} diamantes</div>
            </div>
            <span *ngIf="(!isFinishedPage && !getMaxStake(battle)) || (isFinishedPage && !getMaxStake(battle) && !battle.loot?.gems)">-</span>
          </td>
          <td *ngIf="!isFinishedPage">
            <div class="actions-column">
              <button (click)="resolveBattle(battle)" class="admin-btn admin-btn--primary" [disabled]="!battle.public_id">
                Resolver
              </button>
              <button (click)="openNewModal(battle)" class="admin-btn admin-btn--secondary" style="color: #ff6b6b; border-color: #ff6b6b;" type="button">
                Estornar
              </button>
            </div>
          </td>
          <td *ngIf="isFinishedPage" class="result-column" [ngClass]="getResultClass(battle)">
            <strong>{{ getResultStatus(battle) }}</strong>
          </td>
          <td *ngIf="isFinishedPage">
            <a class="admin-btn admin-btn--secondary" [routerLink]="['/dashboard/battle-list-finished', battle.public_id, 'result']">Alterar resultado</a>
          </td>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="isFinishedPage ? 6 : 5" class="empty-message">
            Nenhuma batalha encontrada
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>

<p-dialog 
  [(visible)]="displayPlayerModal" 
  [header]="'Informações dos Jogadores'" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false" 
  [dismissableMask]="true"
  styleClass="player-modal-dialog"
  (onHide)="closePlayerModal()"
>
  <div *ngIf="selectedBattle" class="player-modal-content">
    
    <div class="players-side-by-side">
      
      <div class="player-section" *ngIf="selectedBattle.players?.[0]">
        <h3 class="player-name">{{ selectedBattle.players[0].username || '-' }}</h3>
        <div class="player-info">
          <p class="player-detail"><strong>ID:</strong> {{ selectedBattle.players[0].user_id || '-' }}</p>
          <p class="player-detail" *ngIf="selectedBattle.players[0].lol_match_started_at"><strong>Horário LoL:</strong> {{ selectedBattle.players[0].lol_match_started_at }}</p>
          <p class="player-detail"><strong>Pontuação:</strong> {{ selectedBattle.players[0].score ?? '-' }}</p>
          <p class="player-detail"><strong>Status da Batalha:</strong> {{ selectedBattle.is_finished ? 'Finalizada' : 'Em Andamento' }}</p>
          <p class="player-detail"><strong>Resultado da Batalha:</strong> {{ getPlayerResult(selectedBattle, 0) }}</p>

          <div *ngIf="selectedBattle.players[0].accepted_mission as mission1; else emptyMission1" class="mission-details-box">
            <h4 class="mission-title"><i class="pi pi-star-fill"></i> Missão Aceita</h4>
            <p class="player-detail"><strong>Missão:</strong> {{ mission1.name }}</p>
            <p class="player-detail"><strong>Apostado:</strong> {{ mission1.stake_coins }} moedas</p>
            <p class="player-detail"><strong>Multiplicador:</strong> {{ mission1.multiplier }}x</p>
            <p class="player-detail"><strong>Resultado:</strong> 
              <span [ngClass]="mission1.win ? 'text-win' : 'text-lose'">
                {{ mission1.win ? 'VITÓRIA' : 'DERROTA' }}
              </span>
            </p>
            <ng-container *ngIf="mission1.win && mission1.transaction_id">
              <p class="player-detail"><strong>Prêmio Pago:</strong> {{ mission1.reward_gems }} diamantes</p>
              <p class="player-detail"><strong>ID Transação:</strong> {{ mission1.transaction_id }}</p>
            </ng-container>
          </div>
          
          <ng-template #emptyMission1>
            <div *ngIf="selectedBattle.players?.[1]?.accepted_mission" class="mission-details-box empty-mission-box">
              <span>Não há nenhuma missão para exibir</span>
            </div>
          </ng-template>

        </div>
      </div>

      <div class="vertical-divider" *ngIf="selectedBattle.players?.[0] && selectedBattle.players?.[1]"></div>

      <div class="player-section" *ngIf="selectedBattle.players?.[1]">
        <h3 class="player-name">{{ selectedBattle.players[1].username || '-' }}</h3>
        <div class="player-info">
          <p class="player-detail"><strong>ID:</strong> {{ selectedBattle.players[1].user_id || '-' }}</p>
          <p class="player-detail" *ngIf="selectedBattle.players[1].lol_match_started_at"><strong>Horário LoL:</strong> {{ selectedBattle.players[1].lol_match_started_at }}</p>
          <p class="player-detail"><strong>Pontuação:</strong> {{ selectedBattle.players[1].score ?? '-' }}</p>
          <p class="player-detail"><strong>Status da Batalha:</strong> {{ selectedBattle.is_finished ? 'Finalizada' : 'Em Andamento' }}</p>
          <p class="player-detail"><strong>Resultado da Batalha:</strong> {{ getPlayerResult(selectedBattle, 1) }}</p>

          <div *ngIf="selectedBattle.players[1].accepted_mission as mission2; else emptyMission2" class="mission-details-box">
            <h4 class="mission-title"><i class="pi pi-star-fill"></i> Missão Aceita</h4>
            <p class="player-detail"><strong>Missão:</strong> {{ mission2.name }}</p>
            <p class="player-detail"><strong>Apostado:</strong> {{ mission2.stake_coins }} moedas</p>
            <p class="player-detail"><strong>Multiplicador:</strong> {{ mission2.multiplier }}x</p>
            <p class="player-detail"><strong>Resultado:</strong> 
              <span [ngClass]="mission2.win ? 'text-win' : 'text-lose'">
                {{ mission2.win ? 'VITÓRIA' : 'DERROTA' }}
              </span>
            </p>
            <ng-container *ngIf="mission2.win && mission2.transaction_id">
              <p class="player-detail"><strong>Prêmio Pago:</strong> {{ mission2.reward_gems }} diamantes</p>
              <p class="player-detail"><strong>ID Transação:</strong> {{ mission2.transaction_id }}</p>
            </ng-container>
          </div>

          <ng-template #emptyMission2>
            <div *ngIf="selectedBattle.players?.[0]?.accepted_mission" class="mission-details-box empty-mission-box">
              <span>Não há nenhuma missão para exibir</span>
            </div>
          </ng-template>

        </div>
      </div>

    </div>
  </div>
</p-dialog>

<p-dialog 
  [(visible)]="displayNewModal" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false" 
  [dismissableMask]="false"
  [closable]="false"
  [showHeader]="false"
  (onHide)="closeNewModal()"
>
  <div class="refund-modal-content">
    <div class="refund-modal-inner">
      <div class="confirmation-content">
        <h3 class="refund-title">Deseja Estornar Batalha?</h3>
        <div class="users-info-box">
          <p class="users-label"><strong>Usuários:</strong></p>
          <div class="users-list">
            <ng-container *ngIf="selectedBattle?.players?.[0] as player1">
              <span class="user-item">{{ player1.username || '-' }} (ID: {{ player1.user_id || '-' }})</span>
            </ng-container>
            <span *ngIf="selectedBattle?.players?.[0] && selectedBattle?.players?.[1]" class="user-separator">|</span>
            <ng-container *ngIf="selectedBattle?.players?.[1] as player2">
              <span class="user-item">{{ player2.username || '-' }} (ID: {{ player2.user_id || '-' }})</span>
            </ng-container>
            <span *ngIf="!selectedBattle?.players?.[0] && !selectedBattle?.players?.[1]" class="user-item">-</span>
          </div>
        </div>
        <p class="refund-message">Ao estornar a partida, ambos os usuários receberão os valores de entrada de volta.</p>
        <div class="modal-buttons-container">
          <button (click)="cancelRefund()" class="modal-button-cancel">Cancelar</button>
          <button (click)="confirmRefund()" class="modal-button-confirm">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
